module.exports = __webpack_public_path__ + "static/media/alcohol-addictions-motivation-getting-help-large.fdfb8415.png";